import React from 'react';
import { Input } from '../Input';

interface TimePickerProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  controlClassName?: string;
  icon?: React.ReactNode;
  iconClassName?: string;
}

const TimePicker = React.forwardRef<HTMLInputElement, TimePickerProps>((props, ref) => (
  <Input
    ref={ref}
    type="time"
    {...props}
  />
));

TimePicker.displayName = 'TimePicker';

export { TimePicker };
